module.exports = "//static.hsappstatic.net/ContentComponents/static-2.71718/img/website-page-zero.svg"